<template>
  <vx-card>
    <place-add
      @done="$router.push({ name: 'system-business-edit', params: { id: $route.params.businessId } })"
      :business-id="$route.params.businessId"
    />
  </vx-card>
</template>

<script>
import PlaceAdd from '@/views/components/forms/PlaceAdd'

export default {
  name: 'BusinessPlaceAdd',
  components: { PlaceAdd }
}
</script>

<style scoped></style>
